import { styled } from "@mui/material/styles";
import { Box, Grid2 } from "@mui/material";

export const SectionWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const StyledGrid = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
